import React, { useState, useEffect } from 'react';
import './FeedbackNotification.css';

const FeedbackNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if user has dismissed the notification
    const dismissed = localStorage.getItem('feedback-notification-dismissed');
    if (!dismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    setIsDismissed(true);
    localStorage.setItem('feedback-notification-dismissed', 'true');
  };

  if (!isVisible || isDismissed) {
    return null;
  }

  return (
    <div className="feedback-notification">
      <div className="feedback-notification-content">
        <span className="feedback-notification-text">
          Help us improve The Ad Shop!{' '}
          <a 
            href="https://tally.so/r/ODDLpY" 
            target="_blank" 
            rel="noopener noreferrer"
            className="feedback-link"
          >
            Share your feedback
          </a>
        </span>
        <button 
          className="feedback-dismiss" 
          onClick={handleDismiss}
          aria-label="Dismiss feedback notification"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default FeedbackNotification;

